import { CheckRounded } from "@mui/icons-material";
import React from "react";

interface Props {
  id: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  label?: string | null;
  readOnly: boolean;
  size?: string;
}

const CheckBox = (props: Props) => {
  const {
    id,
    checked,
    onChange,
    label = "",
    readOnly,
    size = "1rem",
  } = props;

  return (
    <div className="text-sm mr-2 mb-1 flex items-center">
      {!readOnly && (
        <input
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mr-1"
          style={{ width: size, height: size,  accentColor: checked ? "#CF0A2C" : "inherit",  }}
          id={id}
          type="checkbox"
        />
      )}

      {readOnly && (
        <div
          className="shrink-0 border border-black relative mr-1 rounded-sm p-[1px]"
          style={{
            width: size,
            height: size,
          }}
        >
          {checked && (
            <div className="bg-red w-full h-full rounded-sm" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
            <CheckRounded fontSize="small" sx={{color:'white'}}/>

            </div>
          )}
        </div>
      )}

      {label ? (
        <label
          dangerouslySetInnerHTML={{
            __html: label,
          }}
          htmlFor={id}
        ></label>
      ) : (
        <label className="w-full" style={{ height: size }} htmlFor={id} />
      )}
    </div>
  );
};

export default CheckBox;
